



































































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ListMessages
  }
})
export default class TabContainerAlterHist extends BaseComponent {
  @Prop()
  public id;

  @Prop()
  public items;

  @Prop()
  public label;

  tabIndex = 0;
  panelIndex = 0;

  public headers: any = [
    { text: 'Campo', value: 'nome', sortable: false },
    { text: 'Alterações', value: 'alteracao', sortable: false }
  ];

  @Watch('id')
  onIdChange() {
    this.tabIndex = 0;
    this.panelIndex = 0;
  }
}
